module.exports = __webpack_public_path__ + "img/P150T_weapon_44.4163e0f5.png";